/** Readable project Calendar scope, resolved only against the authorized project list. */
import { slugifySegment } from './prettyRoutes';

export function readProjectCalendarScope(pathname: string, search: string): string | null {
  if (!/^\/calendar(?:\/tasks(?:\/[^/]+)?)?\/?$/.test(pathname)) return null;
  const values = new URLSearchParams(search).getAll('project');
  if (values.length === 0) return null;
  // An invalid requested scope must never fall back to the personal calendar.
  return values.length === 1 ? values[0] : '';
}

export function projectCalendarScope(companyName: string, projectName: string): string {
  return `${slugifySegment(companyName)}/${slugifySegment(projectName)}`;
}

export function resolveProjectCalendarScope<T extends { id: string; clientId: string; name: string }>(
  scope: string | null,
  projects: readonly T[],
  companies: readonly { id: string; name: string }[],
): T | null {
  if (!scope || !/^[a-z0-9]+(?:-[a-z0-9]+)*\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(scope)) return null;
  const matches = projects.filter(project => {
    const company = companies.find(candidate => candidate.id === project.clientId);
    return company && projectCalendarScope(company.name, project.name) === scope;
  });
  return matches.length === 1 ? matches[0] : null;
}

export function withProjectCalendarScope(path: string, scope: string | null): string {
  if (scope === null) return path;
  const [pathname, query = ''] = path.split('?');
  const params = new URLSearchParams(query);
  params.set('project', scope);
  return `${pathname}?${params.toString().replace(/%2F/g, '/')}`;
}
